export default "__VITE_ASSET__BIIqry74__"